import './DropDown.css';
import React, { useRef } from 'react';
import { canUseDOM, get } from '../../utils';
import { ReactComponent as IconChevronDown } from '../../resources/icons/IconChevronDown.svg';
import { removeQueryString, addQueryStringMultiple, default as addQueryString, splitter } from './index';
import { useHistory, useLocation } from 'react-router-dom';
import { qsToObject } from '../../utils/querystring';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';

// let facetFilters: any = convertQueryParamsToFacets(queryParams);

export const createFacets = (tagsToDisplay, facets) => {
  let filteredOptions = [];
  if (facets) {
    filteredOptions = tagsToDisplay && tagsToDisplay.length !== 0 ? tagsToDisplay.map(tag => {
      let value = get(tag, 'title.value') || get(tag, 'title.name');
      let name = get(tag, 'name');
      const facetsName = facets[value] || facets[name];
      if (facetsName) {
        return {
          key: value || name || '',
          label: facetsName,
          name
        };
      }
    }).filter(item => item) : Object.keys(facets).map(item => ({
      key: item,
      label: facets[item],
      name: item
    }));
  }
  return filteredOptions;
};
const DropDown = _ref => {
  let {
    fields,
    hideLabel,
    hideAmount,
    showLabel,
    selectAllLabel,
    resultsLabel,
    clearAllLabel,
    buttonYellow,
    openWithWrapper,
    keepOpenOnChange,
    widgetAnalytics,
    facets,
    nbHits,
    setFilter,
    facetsName,
    indexDropDown,
    firstQuery,
    firstFilter,
    wrapperToggle,
    defaultFacets,
    hideDesktopShowButton,
    hideShowButton,
    setSubpanelLabel,
    onChangeCallback,
    onToggleCallback,
    clearAlllFilters,
    analyticss,
    setStartPage,
    getFilterValue,
    primaryColor,
    columnsClass = 'col-md-3',
    resetAllFiltersCallback
  } = _ref;
  const location = useLocation();
  const queryParams = qsToObject(location.search);
  const [isOpen, setisOpen] = React.useState(false);
  const filterName = get(fields, 'name');
  const {
    eventsAnalytics,
    analytics,
    params
  } = analyticss;
  const label = get(fields, 'title.jss.value');
  const tagsToDisplay = get(fields, 'tagsToDisplay.values');
  const showSelectAllOption = get(fields, 'showSelectAllOption.jss.value');
  const selectedTagsToDisplay = get(fields, 'preselectedTags.values') || [];
  const [filteredOptions, setfilteredOptions] = React.useState([]);
  const [filteredLabel, setfilteredLabel] = React.useState('');
  const checkedOptions = useRef([]);
  const selectedPrimaryColor = primaryColor ? primaryColor : 'var(--main-color)';
  const variables = {
    "--listing-dropdown-primary-color": buttonYellow ? 'var(--events-widget-primary-color)' : selectedPrimaryColor
  };
  const checkboxes = /*#__PURE__*/React.createRef();
  let history = useHistory();
  const type = get(fields, 'fieldTypeItem.item.fieldType.value') === 'Dropdown' ? 'radio' : 'checkbox';
  const filterType = get(fields, 'fieldNameItem.item.fieldName.value');
  const rootRef = useRef();
  const toggleFilter = () => {
    setisOpen(!isOpen);
    wrapperToggle(isOpen);
  };
  const cleanOneFilter = (e, facetsName) => {
    const selected = {};
    filteredOptions.forEach(_ref2 => {
      let {
        key,
        label,
        name
      } = _ref2;
      selected[key] = false;
    });
    let selectedCheckboxes = [];
    setFilter(true, undefined, selectedCheckboxes);
    setisOpen(false);
    if (setStartPage) {
      setStartPage(true);
    }
    addQueryStringMultiple(facetsName, selected, history);
    getFilterValue && getFilterValue(fields.name, facetsName, selected);
    e.stopPropagation();
  };
  const clearFilter = e => {
    setisOpen(false);
    setfilteredLabel('');
    setFilter();
    const checkboxesArray = checkboxes.current.querySelectorAll('.input-choice');
    if (setStartPage) {
      setStartPage(true);
    }
    wrapperToggle(true, false);
    removeQueryString(facetsName, history);
    for (let i = 0; i <= checkboxesArray.length - 1; i++) {
      checkboxesArray[i].checked = false;
    }
    checkedOptions.current = [];
    getFilterValue && getFilterValue(fields.name, facetsName, null);
    if (e) {
      e.stopPropagation();
    }
  };
  const setChecked = checkboxes => {
    let setfilteredLabelArray = [];
    const queries = queryParams[`${filterType}`];
    const checkboxesArray = checkboxes && checkboxes.querySelectorAll('.input-choice');
    for (let i = 0; i <= checkboxesArray.length - 1; i++) {
      checkboxesArray[i].checked = false;
    }
    queries && queries.split(splitter).map(item => {
      for (let i = 0; i <= checkboxesArray.length - 1; i++) {
        if (checkboxesArray[i].value === item.split('+').join(' ')) {
          checkboxesArray[i].checked = true;
          if (setfilteredLabelArray.length === 0) {
            setfilteredLabelArray.push(checkboxesArray[i].value);
          } else {
            setfilteredLabelArray.push(', ' + checkboxesArray[i].value);
          }
        }
      }
    });
    const selected = {};
    filteredOptions.forEach(_ref3 => {
      let {
        key,
        label,
        name
      } = _ref3;
      selected[key] = false;
    });
    for (let i = 0; i <= checkboxesArray.length - 1; i++) {
      if (checkboxesArray[i].checked) {
        selected[checkboxesArray[i].value] = true;
      }
    }
    getFilterValue && getFilterValue(fields.name, facetsName, selected);
    if (setfilteredLabelArray.length !== 0) {
      setfilteredLabel(setfilteredLabelArray);
    } else {
      setfilteredLabel('');
    }
  };
  React.useEffect(() => {
    if (firstFilter === true) {
      setfilteredOptions(createFacets(tagsToDisplay, facets));
    } else {}
    if (filterType !== firstQuery) {
      setfilteredOptions(createFacets(tagsToDisplay, facets));
    }
  }, [facets, defaultFacets, facets]);
  React.useEffect(() => {
    if (clearAlllFilters) {
      if (selectedTagsToDisplay && selectedTagsToDisplay.length !== 0) {
        if (selectedTagsToDisplay.length) {
          const preselectedTags = selectedTagsToDisplay.map(tag => get(tag, 'title.value') || get(tag, 'name'));
          if (type === 'radio') {
            addQueryString(facetsName, preselectedTags.join(','), history);
          } else {
            addQueryStringMultiple(facetsName, preselectedTags, history, true);
          }
          const checkboxesArray = checkboxes.current.querySelectorAll('.input-choice');
          const selected = {};
          filteredOptions.forEach(_ref4 => {
            let {
              key,
              label,
              name
            } = _ref4;
            selected[key] = false;
          });
          for (let i = 0; i <= checkboxesArray.length - 1; i++) {
            if (checkboxesArray[i].checked) {
              selected[checkboxesArray[i].value] = true;
            }
          }
          getFilterValue && getFilterValue(fields.name, facetsName, selected);
          setFilter(true);
          resetAllFiltersCallback();
        }
      } else {
        clearFilter();
      }
    }
  }, [clearAlllFilters]);
  React.useEffect(() => {
    setChecked(checkboxes.current);
  }, [filteredOptions, facets]);
  const submitFilters = (e, facetsName) => {
    const checkboxesArray = checkboxes.current.querySelectorAll('.input-choice');
    createFacets(tagsToDisplay, defaultFacets);
    const selected = {};
    filteredOptions.forEach(_ref5 => {
      let {
        key,
        label,
        name
      } = _ref5;
      selected[key] = false;
    });
    let selectedCheckboxes = [];
    for (let i = 0; i <= checkboxesArray.length - 1; i++) {
      if (checkboxesArray[i].checked) {
        selected[checkboxesArray[i].value] = true;
        selectedCheckboxes.push(checkboxesArray[i].value);
      }
    }
    setFilter(true, undefined, selectedCheckboxes);
    selectedCheckboxes = selectedCheckboxes.toString();

    // if (!keepOpenOnChange) {
    setisOpen(false);
    if (setStartPage) {
      setStartPage(true);
    }
    // }
    addQueryStringMultiple(facetsName, selected, history);
    getFilterValue && getFilterValue(fields.name, facetsName, selected);
    e.stopPropagation();
  };
  const closeDropdwn = event => {
    if (event.target.closest) {
      if (event.target.closest('.filter__field') !== rootRef.current && !event.target.closest('.filter__header')) {
        setisOpen(false);
        wrapperToggle(true);
      } else if (event.target.closest('.filter__header-links')) {
        setisOpen(false);
        wrapperToggle(true);
      }
    } else {
      setisOpen(false);
      wrapperToggle(true);
    }
  };
  React.useEffect(() => {
    const queries = queryParams[`${filterType}`];
    if (!queries && selectedTagsToDisplay.length) {
      const preselectedTags = selectedTagsToDisplay.map(tag => get(tag, 'title.value') || get(tag, 'name'));
      if (type === 'radio') {
        addQueryString(facetsName, preselectedTags.join(','), history);
      } else {
        addQueryStringMultiple(facetsName, preselectedTags, history);
      }
      const checkboxesArray = checkboxes.current.querySelectorAll('.input-choice');
      const selected = {};
      filteredOptions.forEach(_ref6 => {
        let {
          key,
          label,
          name
        } = _ref6;
        selected[key] = false;
      });
      for (let i = 0; i <= checkboxesArray.length - 1; i++) {
        if (checkboxesArray[i].checked) {
          selected[checkboxesArray[i].value] = true;
        }
      }
      getFilterValue && getFilterValue(fields.name, facetsName, selected);
      setFilter(true);
    }
    document.body.addEventListener('click', closeDropdwn);
    return () => {
      removeQueryString(facetsName, history);
    };
  }, []);
  const setTemporaryLabel = e => {
    const currentName = e.target.value;
    filteredOptions.map(el => {
      if (el.key === currentName) {
        if (!checkedOptions.current.includes(currentName)) {
          checkedOptions.current = [...checkedOptions.current, currentName];
        } else {
          checkedOptions.current.splice(checkedOptions.current.indexOf(currentName), 1);
        }
      }
    });
    const checkboxesArray = checkboxes.current.querySelectorAll('.input-choice');
    const selected = {};
    filteredOptions.forEach(_ref7 => {
      let {
        key,
        label,
        name
      } = _ref7;
      selected[key] = false;
    });
    for (let i = 0; i <= checkboxesArray.length - 1; i++) {
      if (checkboxesArray[i].checked) {
        selected[checkboxesArray[i].value] = true;
      }
    }
    if (checkedOptions.current.length !== 0) {
      setfilteredLabel(checkedOptions.current.toString());
      getFilterValue && getFilterValue(fields.name, facetsName, selected);
    } else {
      setfilteredLabel('');
      getFilterValue && getFilterValue(fields.name, facetsName, null);
    }
  };
  const clearAllAnalyticsClick = () => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["filterClearDateAnalytics"], params), label);
  };
  const showResultAnalyticsClick = () => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["filterShowResultsAnalytics"], params), label);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    columnsClass: columnsClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field filter__field-dropdown",
    ref: rootRef,
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: `filter-panel eloqua ${isOpen ? 'filter-panel--open' : ''}`
  }, hideLabel ? null : /*#__PURE__*/React.createElement("div", {
    className: "body-small filter-panel__mob-label"
  }, label), /*#__PURE__*/React.createElement("div", {
    tabIndex: 0,
    className: `filter-panel__box ${isOpen ? 'filter-panel__box--openedDrop' : ''}`,
    onClick: () => {
      onToggleCallback && onToggleCallback();
      if (setStartPage) {
        setStartPage(isOpen);
      }
      if (openWithWrapper) {
        toggleFilter();
      } else {
        setisOpen(!isOpen);
      }
    },
    onKeyPress: event => {
      if (event.key === 'Enter' || event.key === 'NumpadEnter' || event.which === 32) {
        event.preventDefault();
        onToggleCallback && onToggleCallback();
        if (openWithWrapper) {
          toggleFilter();
        } else {
          setisOpen(!isOpen);
        }
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "filter-panel__trigger js-filter-panel__trigger"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__text body-small"
  }, filteredLabel ? filteredLabel : label), /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner-scroll"
  }, clearAllLabel ? /*#__PURE__*/React.createElement("div", {
    className: "fp__inner-cb"
  }, showSelectAllOption ? /*#__PURE__*/React.createElement("span", {
    tabIndex: 0,
    className: "body-medium fp__inner-clear cursor-pointer",
    onClick: e => {
      const inputs = checkboxes.current.querySelectorAll('.input-choice');
      inputs.forEach(input => {
        input.checked = true;
      });
      wrapperToggle(true);
      submitFilters(e, facetsName);
    },
    onKeyPress: e => {
      if (e.key === 'Enter' || e.key === 'NumpadEnter' || e.which === 32) {
        e.preventDefault();
        const inputs = checkboxes.current.querySelectorAll('.input-choice');
        inputs.forEach(input => {
          input.checked = true;
        });
        wrapperToggle(true);
        submitFilters(e, facetsName);
      }
    }
  }, selectAllLabel ? selectAllLabel : '') : /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("button", {
    className: "body-medium fp__inner-clear cursor-pointer btn--reset",
    onClick: e => {
      cleanOneFilter(e, facetsName);
      // clearFilter(e);
      clearAllAnalyticsClick();
    },
    onKeyPress: e => {
      if (e.which === 13) {
        e.preventDefault();
        // clearFilter(e);
        cleanOneFilter(e, facetsName);
        clearAllAnalyticsClick();
      }
    }
  }, clearAllLabel)) : null, /*#__PURE__*/React.createElement("div", {
    ref: checkboxes
  }, filteredOptions.map((item, index) => {
    const {
      key,
      label,
      name
    } = item;
    const idKey = `${facetsName}_${key.replace(/\s/g, '_')}`;
    return /*#__PURE__*/React.createElement("label", {
      className: "checkbox-aligned fp__inner-label",
      htmlFor: idKey,
      key: index
    }, /*#__PURE__*/React.createElement("input", {
      tabIndex: 0,
      className: `input-choice ${type === 'radio' ? 'fp__radio' : 'fp__checkbox'}`,
      type: type
      // defaultChecked={setChecked(key, filterType)}
      ,

      name: `dropdown=${indexDropDown}`,
      value: key,
      onKeyPress: e => {
        if (e.key === 'Enter' || e.key === 'NumpadEnter') {
          e.preventDefault();
          e.target.checked = !e.target.checked;
          onChangeCallback && onChangeCallback();
          setTemporaryLabel(e);
          !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), `${filterName}: ${name ? name : key}`);
          if (hideDesktopShowButton) {
            if (canUseDOM && window.innerWidth >= 768) {
              submitFilters(e, facetsName);
              wrapperToggle(true);
            }
          } else if (hideShowButton) {
            submitFilters(e, facetsName);
            wrapperToggle(true);
          }
        }
      },
      onChange: e => {
        onChangeCallback && onChangeCallback();
        setTemporaryLabel(e);
        !widgetAnalytics && tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), `${filterName}: ${name ? name : key}`);
        if (hideDesktopShowButton) {
          if (canUseDOM && window.innerWidth >= 768) {
            submitFilters(e, facetsName);
            wrapperToggle(true);
          }
        } else if (hideShowButton) {
          submitFilters(e, facetsName);
          // wrapperToggle(false);
          setisOpen(true);
        }
      },
      id: idKey
    }), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-text"
    }, key, " ", hideAmount ? null : `(${label})`), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-bg"
    }));
  }))), !hideDesktopShowButton || !hideShowButton ? /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__bottom"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary js-btn-close-panel",
    onClick: e => {
      wrapperToggle(true);
      submitFilters(e, facetsName);
      showResultAnalyticsClick();
    }
  }, showLabel, " ", resultsLabel)) : null))));
};
const StyledWrapper = _ref8 => {
  let {
    children,
    columnsClass
  } = _ref8;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${columnsClass}`
  }, children);
};

// export default DropDown;
export default DropDown;
const commonStyles = "ctl7p1s";